import difficulties from './difficulties';
import tier from './tier';

export { difficulties, tier };



// WEBPACK FOOTER //
// ./src/consts/index.ts